import { useMutation } from '@apollo/client/react';
import { useCallback } from 'react';
import { useViewer } from '@/features/session';
import { CANCEL_PLAN } from '@/graphql/mutations/billing';

type UseCancelPlanResult = { cancelPlan: () => Promise<void>; isCancelling: boolean };

/** Cancels at the end of the period; Paddle keeps the plan on until then. */
export function useCancelPlan(): UseCancelPlanResult {
  const { refreshViewer } = useViewer();
  const [mutate, { loading }] = useMutation(CANCEL_PLAN);

  const cancelPlan = useCallback(async () => {
    await mutate();
    await refreshViewer();
  }, [mutate, refreshViewer]);

  return { cancelPlan, isCancelling: loading };
}
